export const GET_SERVICE_PROVIDERS_LIST = "GET_SERVICE_PROVIDERS_LIST";
export const SET_SERVICE_PROVIDERS_LIST = "SET_SERVICE_PROVIDERS_LIST";

export const ADD_SERVICE_PROVIDER = "ADD_SERVICE_PROVIDER";
export const DELETE_SERVICE_PROVIDER = "DELETE_SERVICE_PROVIDER";
export const GET_SERVICE_PROVIDER = "GET_SERVICE_PROVIDER";
export const SET_SERVICE_PROVIDER = "SET_SERVICE_PROVIDER";

export const UPDATE_SERVICE_PROVIDER = "UPDATE_SERVICE_PROVIDER";
export const SET_ERROR_SERVICE_PROVIDER = "SET_ERROR_SERVICE_PROVIDER";

export const GET_SERVICE_PROVIDER_WIDGET = "GET_SERVICE_PROVIDER_WIDGET";
export const SET_SERVICE_PROVIDER_WIDGET = "SET_SERVICE_PROVIDER_WIDGET";

export const SET_SERVICE_PROVIDER_DATE = "SET_SERVICE_PROVIDER_DATE";
export const SET_SERVICE_PROVIDER_RESULT = "SET_SERVICE_PROVIDER_RESULT";

/* LOADER */
export const SERVICE_PROVIDER_PROFILE_LOADER = "SERVICE_PROVIDER_PROFILE_LOADER";
export const SERVICE_PROVIDER_LIST_LOADER = "SERVICE_PROVIDER_LIST_LOADER";
export const SET_SERVICE_PROVIDER_WIDGET_LOADER = "SET_SERVICE_PROVIDER_WIDGET_LOADER"